import { Lock } from 'lucide-react';
import ToggleSwitch from '../ui/ToggleSwitch';

/**
 * "Seller Mode" switch - renamed from the old "User Management" control.
 *
 * IMPORTANT: the backend scopes the inbox by the account role
 * (`getConversations()` filters on `buyerId` for a BUYER and `sellerId` for a
 * SELLER), and there is no query parameter to request the other side. So this
 * shows which inbox the server is actually returning and is locked, rather than
 * pretending to switch. Making it genuinely switchable needs a backend change -
 * see the Phase 5 note in README.md.
 */
export default function SellerModeToggle({ enabled, inboxLabel, disabled = false, hint }) {
  return (
    <div
      className={`flex items-center justify-between gap-3 rounded-xl border px-3 py-2.5 transition-colors ${
        enabled ? 'border-brand-200 bg-brand-soft dark:border-brand-800' : 'border-line bg-surface'
      }`}
    >
      <div className="min-w-0">
        <span className="flex items-center gap-1.5 text-[13px] font-medium text-ink">
          Seller Mode
          {disabled && <Lock size={11} className="text-ink-3" aria-label="Locked" />}
        </span>
        <p className="truncate text-[11px] text-ink-3" title={hint} aria-live="polite">
          {inboxLabel}
        </p>
      </div>

      <ToggleSwitch
        id="z2-seller-mode"
        checked={enabled}
        disabled={disabled}
        onChange={() => {}}
        label={
          disabled
            ? 'Seller Mode is set by your account role'
            : 'Seller Mode - switch between your buying and selling inboxes'
        }
      />
    </div>
  );
}
